import React, {FC} from 'react';
import {styled} from '@linaria/react';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../../atoms/Icon/Icon';
import {css, cx} from '@linaria/core';
import {useHistory} from '@aboutyou/router';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

export const InfoIconWithLink: FC<{
  className?: string;
  to: string;
  dataTestId?: string;
  renderAsAButton?: boolean;
}> = ({className, to, dataTestId = 'infoIconWithLink', renderAsAButton}) => {
  const {push} = useHistory();

  const content = (
    <>
      <BlackBackground />
      <StyledIcon
        asset={GenericIconName.InfoWithoutFill}
        size="XS"
        fill={COLORS.White}
      />
    </>
  );

  if (renderAsAButton) {
    return (
      <button
        onClick={e => {
          e.preventDefault();
          push(to);
        }}
        className={cx(WrapperCss, className)}
        data-testid={dataTestId}
      >
        {content}
      </button>
    );
  }

  return (
    <UnstyledLinkLinaria
      to={to}
      className={cx(WrapperCss, className)}
      data-testid={dataTestId}
    >
      {content}
    </UnstyledLinkLinaria>
  );
};

const WrapperCss = css`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
`;

const BlackBackground = styled.div`
  background-color: ${COLORS.Black};
  border-radius: 50%;
  inset: 0;
  position: absolute;
  transform: scale(0.9);
  z-index: 0;
`;

const StyledIcon = styled(Icon)`
  position: relative;
  z-index: 1;
`;
